var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-animate",rawName:"v-lazy-animate"}],staticClass:"brand-intro-wrap"},[_c('div',{staticClass:"brand-intro-head"}),_c('Anchor'),_c('BrandLine',{attrs:{"brandInfo":_vm.brandInfo}}),_c('BrandActivities'),_c('DevelopmentPath',{attrs:{"id":"anchor-bar-4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }